import React, { useState } from "react";
import "../../Styles/Modal.css";
import { ImCancelCircle } from "react-icons/im";
import { CircularProgress } from "@mui/material";
import axios from "axios";
import Swal from "sweetalert2";

const ConfirmDeleteCustomer = ({
  handleConfirmDelete,
  edit,
  customer,
}: any) => {
  const [loading, setLoading] = useState(false);
  const [reLogin, setReLogin] = useState(false);
  const token = window.localStorage.getItem("token");

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  const handleDelete = (e: any) => {
    e.preventDefault();
    setLoading(true);

    axios
      .delete(`https://apibiz.oneflaretech.com/api/customer/${customer._id}`, {
        headers: headers,
      })
      .then((res) => {
        Swal.fire({
          title: `Success!`,
          text: `${res.data.message}`,
          icon: "success",
          showCancelButton: false,
          confirmButtonColor: "green",
          confirmButtonText: "Continue",
        });
        setLoading(false);
        // handlClose();
        window.location.reload();
      })
      .catch((err) => {
        if (
          err.response.data.message === "jwt expired" ||
          err.response.data.message === "jwt malformed"
        ) {
          setReLogin(true);
        } else {
          setReLogin(false);
        }
        Swal.fire({
          title: `Error!`,
          text: `${err.response.data.message}`,
          icon: "error",
          showCancelButton: false,
          confirmButtonColor: "red",
          // cancelButtonColor: "red",
          confirmButtonText: "Try Again",
          // cancelButtonText: "Leave Page",
        });
        setLoading(false);
      });
  };

  return (
    <div className="modal">
      <div className="catModal">
        <div className="catModalTop">
          <h4>Delete Customer</h4>
          <ImCancelCircle className="catCancel" onClick={handleConfirmDelete} />
        </div>
        <div className="line"></div>
        <div style={{ textAlign: "center" }}>
          <h3>Confim Delete</h3>
          <p>Confirm you want to delete this customer ({edit.businessName})</p>
        </div>
        <div className="catModalBtn">
          <button
            className="catBtn1"
            style={{ width: "135px", background: "#ff0303" }}
            onClick={handleDelete}
          >
            {loading ? (
              <CircularProgress
                style={{ color: "#fff", width: "25px", height: "25px" }}
              />
            ) : (
              "Delete"
            )}
          </button>
          <button className="catBtn2" onClick={handleConfirmDelete}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDeleteCustomer;
